import {IMGPW} from '@/config';
import Image from 'next/image';

function SectionPress() {
  return (
    <section className="container tw-space-y-8">
      <div className="tw-col-span-2">
        <h3 className="tw-text-4xl tw-font-bold tw-tracking-tighter tw-mb-4 tw-text-gray-800">
          Das italienische Unternehmen mit der höchsten durchschnittlichen Wachstumsrate von 2018
          bis 2021. Neunter in Europa.
        </h3>
      </div>
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6">
        <div className="tw-w-full tw-flex-1 tw-flex tw-gap-4 tw-border tw-border-gray-300 tw-shadow-lg tw-rounded tw-p-4">
          <div className="position-relative tw-h-16 tw-w-16">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={IMGPW + '/ilsole24.jpeg'}
              alt="Il Sole 24 Ore"
            />
          </div>
          <div>
            <div className="tw-text-lg tw-font-medium tw-tracking-tight tw-text-gray-800 tw-mt-2">
              <span>1. Platz - </span>
              <a
                href="https://lab24.ilsole24ore.com/leader-della-crescita-2022/?refresh_ce=1"
                target="_blank"
              >
                Wachstumsführer 2022
              </a>
            </div>
            <div className="tw-text-base tw-font-medium tw-tracking-tight tw-text-gray-500">
              Il Sole 24 Ore
            </div>
          </div>
        </div>
        <div className="tw-w-full tw-flex-1 tw-flex tw-gap-4 tw-border tw-border-gray-300 tw-shadow-lg tw-rounded tw-p-4">
          <div className="position-relative tw-h-16 tw-w-12">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={IMGPW + '/ft1200.png'}
              alt="Financial Times"
            />
          </div>
          <div>
            <div className="tw-text-lg tw-font-medium tw-tracking-tight tw-text-gray-800 tw-mt-2">
              <span>9. Platz - </span>
              <a href="https://www.ft.com/ft1000-2022" target="_blank">
                FT1000 Europas am schnellsten wachsende Unternehmen
              </a>
            </div>
            <div className="tw-text-base tw-font-medium tw-tracking-tight tw-text-gray-500">
              Financial Times
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionPress;
